// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.TermsCondition_textBoxStyle__uhIIG {
  overflow: auto;
  height: 370px;
  padding-right: 20px;
  text-align: justify;
}`, "",{"version":3,"sources":["webpack://./src/component/common/modal/terms-condition/TermsCondition.module.scss"],"names":[],"mappings":"AAAA;EACE,cAAA;EACA,aAAA;EACA,mBAAA;EACA,mBAAA;AACF","sourcesContent":[".textBoxStyle {\n  overflow: auto;\n  height: 370px;\n  padding-right: 20px;\n  text-align: justify;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"textBoxStyle": `TermsCondition_textBoxStyle__uhIIG`
};
export default ___CSS_LOADER_EXPORT___;
